// Environment-driven config. Set these in .env.development / .env.production
// (REACT_APP_* is required by Create React App). The hardcoded values are
// kept as fallbacks so existing builds keep working without a .env file.
export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://backend.manaprint.in/public/api/client";

export const CDN_URL =
  process.env.REACT_APP_CDN_URL || "https://cdn.acsdev.in/ManaPrint";

// Google OAuth "Web application" client ID (public — safe to expose in the browser).
// Must match GOOGLE_CLIENT_ID in the backend .env so the backend can verify the token.
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "1089667522617-inr3ogbri7d9voub8ef5orfl7kk3f0a1.apps.googleusercontent.com";


// Production Urls::

// Client::
// https://manaprint.in/
// https://manaprint.com/

// Admin:: 
// https://admin.manaprint.com/
 
// Backend::

// 	CLIENT BASE_URL :: https://backend.manaprint.com/public/api/client

// 	ADMIN BASE URL :: https://backend.manaprint.com/public/api


// Testing Urls:: 

// Client::
// https://testing.manaprint.in

// Admin:: 
// https://admintest.manaprint.com/

// Backend::

// 	CLIENT BASE_URL :: https://backend.manaprint.in/public/api/client

// 	ADMIN BASE_URL :: https://backend.manaprint.in/public/api

// Manaprint | Personalized Gifts & Custom Printing Online
// Discover unique personalized gifts and custom printing at Manaprint ecommerce gift shop.
 